import * as CryptoJS from 'crypto-js';

window.serverUrl = !process.env.REACT_APP_NTF_SERVER_URL ? "http://localhost:3001" : `https://${process.env.REACT_APP_NTF_SERVER_URL}`;

window.reqServer = (path, method, data, callback=()=>0, isReload=true) => {
	if(method.toLowerCase() === "get") {
		isReload = false;
		data = {headers: {...data}};
	}
	if(!data.headers) data = {body: {...data}};
	fetch(`${window.serverUrl}/ntf_api${path}`, {
		method,
		headers: {
			"Content-Type": "application/json",
			...data.headers, password: process.env.REACT_APP_NTF_SERVER_PASSWORD,
			adminbackendkey: process.env.REACT_APP_NTF_SERVER_KEY,
		},
		body: JSON.stringify(data.body),
	}).then((res)=>res.json()).then((res)=>{
		callback(res);
		if(isReload) window.reload();
	}).catch((e)=>console.error(path + " - " + JSON.stringify(data.headers) + " - " + e));
};

window.setData = async (key, value) => {
	localStorage.setItem(key, CryptoJS.AES.encrypt(value, process.env.REACT_APP_LOCAL_PASSWORD).toString());
}

window.getData = async (key) => {
	return CryptoJS.AES.decrypt(localStorage.getItem(key)||"", process.env.REACT_APP_LOCAL_PASSWORD).toString(CryptoJS.enc.Utf8);
}